import { buildAsturHeaders } from '@/endpoints/channel/asturHeaders';
import { scopedChannelApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ChannelApiResponse } from '@/types/endpoints';
import { utils } from '@/utils';
import type { WriteRequestOptions } from '../../requestOptions';
import type { CategoryPlanRun } from './types';

export type CategoryPlanDecideBody = Readonly<{
  suggestion_ids: number[];
  decision: 'approved' | 'rejected' | 'pending';
  feedback?: string | null;
  decided_by?: string | null;
}>;

export type CategoryPlanDecideData = Readonly<{ updated: number; run: CategoryPlanRun }>;

type CategoryPlanDecideResponse = Readonly<{ updated: number; run: CategoryPlanRun }>;

export async function decideCategoryPlanSuggestions(
  scope: RequestScope,
  args: {
    runId: number;
    body: CategoryPlanDecideBody;
  },
  options: WriteRequestOptions
): Promise<ChannelApiResponse<CategoryPlanDecideData>> {
  try {
    const res = await scopedChannelApi(scope).post<CategoryPlanDecideResponse>(`atts/category-plan/runs/${args.runId}/decisions`, args.body, {
      ...options,
      headers: buildAsturHeaders(),
    });

    if (typeof res.data?.updated !== 'number' || !res.data?.run) {
      throw new Error('Invalid decision response');
    }

    return { data: { updated: res.data.updated, run: res.data.run }, status: res.status };
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
}
